import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("客户同步")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 财务客户管理列表
  'POST/client_management/list': fetchList,
  // 国别列表
  'GET/order/receivable/clients/countries': countriesListApi,
  // 客户状态
  'POST/client_management/list_status': list_statusApi,
  // 客户管理同步
  'POST/customer_basic_info/sync': syncApi,
} = Api

const searchEle = ref()
const countrieList: any = ref([])
const statusList: any = ref([])
onBeforeMount(() => {
  countriesListApi().then((rep: any) => {
    countrieList.value = rep
  })

  list_statusApi().then((rep: any) => {
    statusList.value = rep
  })
})

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchObj = reactive({
  company: '', salesChannel: '', customerType: '',
  pm: '', amRatio: '', industry: '', status: '',
  teams: [], time: [], country: '',
})

const searchHandle = () => {
  fetchData({
    ...searchObj,
    startTime: searchObj.time[0],
    endTime: searchObj.time[1],
  })
}
searchHandle()

// 客户同步
const isShowSync = ref<boolean>(false)
const btnLoad = ref<boolean>(false)
const syncObj = reactive({
  range: [], type: '',
})
const syncHandle = () => {
  btnLoad.value = true
  syncApi({
    from: syncObj.range?.[0],
    to: syncObj.range?.[1],
    type: syncObj.type
  }, {contentType: 'formData'}).then(() => {
    ElMessage.success('更新成功')
    isShowSync.value = false
    searchHandle()
  }).finally(() => {
    btnLoad.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "客户列表-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              disabled: _unref(MI_identify),
              model: _unref(searchObj),
              "label-width": "90px",
              inline: true,
              ref_key: "searchEle",
              ref: searchEle,
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "客户名:",
                  prop: "company"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(searchObj).company,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).company) = $event)),
                      placeholder: "请输入客户名",
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "国家:",
                  prop: "country"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择团队",
                      modelValue: _unref(searchObj).country,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).country) = $event)),
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countrieList.value, (coun) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: coun,
                            value: coun,
                            key: coun
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "CRM平台:",
                  prop: "salesChannel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "formItem",
                      modelValue: _unref(searchObj).salesChannel,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).salesChannel) = $event)),
                      placeholder: "请选择CRM平台",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "CCJK.com",
                          value: "CCJK.com"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Chamber",
                          value: "Chamber"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Elance",
                          value: "Elance"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Email",
                          value: "Email"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户性质:",
                  prop: "customerType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "formItem",
                      modelValue: _unref(searchObj).customerType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).customerType) = $event)),
                      placeholder: "请选择客户性质",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Translation Agency",
                          value: "Translation Agency"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Business",
                          value: "Business"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Personal",
                          value: "Personal"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "pm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).pm,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).pm) = $event)),
                      class: "form-input",
                      placeholder: "请选择客户经理",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: `${user.alias} (${user.realName})`,
                            value: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "AM:",
                  prop: "amRatio"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).amRatio,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).amRatio) = $event)),
                      class: "form-input",
                      placeholder: "请选择AM",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: `${user.alias} (${user.realName})`,
                            value: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "行业:",
                  prop: "industry"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(searchObj).industry,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).industry) = $event)),
                      placeholder: "请输入行业",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "状态:",
                  prop: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "formItem",
                      modelValue: _unref(searchObj).status,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).status) = $event)),
                      placeholder: "请选择状态",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusList.value, (status) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: status,
                            value: status,
                            key: status
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "teams"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择团队",
                      modelValue: _unref(searchObj).teams,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).teams) = $event)),
                      filterable: "",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "记录日期:",
                  prop: "time"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).time,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchObj).time) = $event)),
                      type: "daterange",
                      clearable: "",
                      "range-separator": "至",
                      "value-format": "YYYY-MM-DD",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => {searchEle.value.resetFields(); _unref(searchObj).teams = []; _unref(searchObj).time = []})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled", "model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[12] || (_cache[12] = ($event: any) => (isShowSync.value = true)),
      class: "mt-10",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 20 + 'px',
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "用户名",
          prop: "username",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "国家",
          prop: "country",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "CRM平台",
          prop: "salesChannel",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户性质",
          prop: "customerType",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "最近下单日期",
          prop: "lastOrderTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "记录日期",
          prop: "createTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "pmRatio",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.username + row.pmRatio), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "PM",
          prop: "pm",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "AM",
          prop: "amRatio",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.username + row.amRatio), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Share",
          prop: "share",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "销售渠道",
          prop: "independent",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "行业",
          prop: "industry",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (_ctx.$router.push({name: 'financialCustomerDetails', params: {id: row.username}}))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      class: "mt-10",
      disabled: _unref(MI_identify),
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[14] || (_cache[14] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowSync.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isShowSync).value = $event)),
      title: "同步客户",
      onClose: _cache[20] || (_cache[20] = ($event: any) => (_unref(syncObj).range = [], _unref(syncObj).type = ''))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (isShowSync.value = false)),
          disabled: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (syncHandle())),
          loading: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(syncObj),
          inline: "",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "时间范围:",
              prop: "range"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(syncObj).range,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(syncObj).range) = $event)),
                  "value-format": "YYYY-MM-DD",
                  "end-placeholder": "结束日期",
                  type: "daterange",
                  "start-placeholder": "开始日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型:",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(syncObj).type,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(syncObj).type) = $event)),
                  placeholder: "请选择类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "创建",
                      value: "create"
                    }),
                    _createVNode(_component_el_option, {
                      label: "更新",
                      value: "update"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})